import Config from '../config/constants';
import axios, { AxiosResponse } from 'axios';

export const apiGetDailyUserCnt = async (accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/dashboard/dailyusercnt`;

    try {
        const response = await axios.get(url, {
            headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching daily user count:', error);
        throw error;
    }
};

export const apiGetTodayTop10Users = async (accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/dashboard/todayTop10Users`;

    try {
        const response = await axios.get(url, {
            headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching top 10 users:', error);
        throw error;
    }
};

export const apiGetDailyPetCnt = async (accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/dashboard/dailypetcnt`;

    try {
        const response = await axios.get(url, {
            headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching daily pet count:', error);
        throw error;
    }
};

export const apiGetTodayPetCntByBranch = async (accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/dashboard/todayPetCntbyBranch`;

    try {
        const response = await axios.get(url, {
            headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching todays pet count by branch:', error);
        throw error;
    }
};

export const apiGetTodayPetCntHour = async (accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/dashboard/todayPetCntHour`;

    try {
        const response = await axios.get(url, {
            headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching todays pet count by hour:', error);
        throw error;
    }
};


export const apiGetTotalPoints = async (accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/dashboard/totalPoints`;

    try {
        const response = await axios.get(url, {
            headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching todays pet count by hour:', error);
        throw error;
    }
};


